import React, {Component} from "react";

class HistoryHeader extends Component {
    render() {
        const {pastReservation} = this.props;
        return (
            <div className="row doctor-details">
                <div className="col-md-9 history-doctor flex">
                    <img className="doctor-image mr-20" src={pastReservation.doctor.image} alt="doctor"/>
                    <div className="width-percentage-100">
                        <a className="no-padding"
                           href={"/doctor/" + pastReservation.doctor.unique_id}>
                            <h5 className="trimmed-p">{pastReservation.doctor.name}</h5>
                        </a>
                        <p className="trimmed-p"> <span className="inline-block"><img alt="pin" className="mr-10"
                                                                                      src="../../images/history_pin.png"/></span>
                            {pastReservation.clinic && pastReservation.clinic.pattern === 0 ? pastReservation.address : pastReservation.clinic_name}
                        </p>
                    </div>
                </div>
                <div className="col-md-1 offset-2">
                    <a
                        className="pastResCollapse"
                        id="toggle-collapse"
                        data-toggle="collapse"
                        href={"#pastResDetails" + pastReservation.id}
                        aria-expanded="false"
                        aria-controls="pastResDetails">

                        <span className="collapsed"><i className="fas fa-chevron-up"></i></span>
                        <span className="expanded"><i className="fas fa-chevron-down"></i></span>
                    </a>
                </div>
            </div>
        )
    }
}

export default HistoryHeader;
